import { BUSINESS } from "../../../mocks/businessData";

const HERO_BG =
  "https://public.readdy.ai/ai/img_res/45a0958a00238cc4ea4fbaf78a5febe5.jpg";

const STATS = [
  { icon: "ri-star-fill",      value: "340+",  label: "5-Star Reviews" },
  { icon: "ri-history-line",   value: "40+",   label: "Years of Mastery" },
  { icon: "ri-time-line",      value: "24/7",  label: "Always Available" },
  { icon: "ri-truck-line",     value: "Free",  label: "Pickup & Delivery" },
];

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-screen flex items-end overflow-hidden">
      {/* ── Cinematic Background ── */}
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat hero-img-bg"
        style={{ backgroundImage: `url(${HERO_BG})` }}
      />

      {/* ── Layered Overlays ── */}
      <div className="absolute inset-0 bg-gradient-to-r from-stone-950/95 via-stone-950/80 to-stone-900/50" />
      <div className="absolute inset-0 bg-gradient-to-b from-stone-950/60 via-transparent to-stone-950/85" />

      {/* ── Subtle noise texture ── */}
      <div
        className="absolute inset-0 opacity-[0.03] pointer-events-none mix-blend-overlay"
        style={{
          backgroundImage:
            "url(\"data:image/svg+xml,%3Csvg width='300' height='300' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.75' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='300' height='300' filter='url(%23n)'/%3E%3C/svg%3E\")",
        }}
      />

      {/* ── Vertical gold accent line ── */}
      <div className="absolute left-0 top-0 bottom-0 w-px bg-gradient-to-b from-transparent via-amber-600/40 to-transparent hidden lg:block" />

      {/* ── Content ── */}
      <div className="relative z-10 w-full px-8 md:px-16 lg:px-28 max-w-7xl mx-auto pt-36 pb-24">
        {/* Badge */}
        <div className="hero-badge flex items-center gap-3 mb-9">
          <span className="inline-block w-10 h-px bg-amber-500" />
          <span className="text-amber-400 text-xs tracking-[0.40em] uppercase font-medium">
            New Jersey&apos;s Premier Cleaning Artisans · Est. 40+ Years
          </span>
        </div>

        {/* Headline */}
        <h1 className="hero-h1 font-serif font-light text-white leading-[1.03] max-w-4xl mb-7">
          <span className="block text-5xl md:text-7xl lg:text-[5.5rem]">
            Restore the Luxury
          </span>
          <span className="block text-5xl md:text-7xl lg:text-[5.5rem] italic text-amber-300 mt-1">
            Your Home Deserves.
          </span>
        </h1>

        {/* Thin gold rule */}
        <div className="hero-sub w-20 h-px bg-gradient-to-r from-amber-500 to-transparent mb-8" />

        {/* Subheading */}
        <p className="hero-sub text-stone-300 text-base md:text-xl max-w-lg leading-relaxed font-light mb-4">
          White-glove drapery &amp; blind cleaning — picked up from your home,
          meticulously restored at our facility, and rehung to perfection.
        </p>
        <p className="hero-sub text-white/55 text-sm md:text-base max-w-md leading-relaxed mb-12">
          Protecting your investment. Preserving your home&apos;s beauty.
          <strong className="text-amber-400/90 font-medium ml-1">Open 24/7.</strong>
        </p>

        {/* CTAs */}
        <div className="hero-ctas flex flex-col sm:flex-row items-start gap-4 mb-16">
          <a
            href="#quote-form"
            onClick={(e) => {
              e.preventDefault();
              document.getElementById("quote-form")?.scrollIntoView({ behavior: "smooth" });
            }}
            className="btn-luxury bg-amber-700 hover:bg-amber-600 text-white text-xs tracking-[0.25em] uppercase font-semibold px-10 py-4 rounded-sm whitespace-nowrap cursor-pointer"
          >
            Schedule Complimentary Pickup
          </a>
          <a
            href={BUSINESS.phoneHref}
            className="btn-luxury flex items-center gap-2.5 border border-white/30 hover:border-amber-400/70 bg-white/5 hover:bg-white/10 text-white hover:text-amber-300 text-xs tracking-[0.25em] uppercase font-semibold px-10 py-4 rounded-sm whitespace-nowrap cursor-pointer transition-colors duration-300"
          >
            <span className="w-4 h-4 inline-flex items-center justify-center">
              <i className="ri-phone-fill text-xs" />
            </span>
            {BUSINESS.phone}
          </a>
        </div>

        {/* ── Proof stats glass bar ── */}
        <div className="hero-stats">
          <div className="inline-flex flex-col sm:flex-row divide-y sm:divide-y-0 sm:divide-x divide-white/10 border border-white/10 bg-black/30 backdrop-blur-sm">
            {STATS.map((s, i) => (
              <div key={i} className="flex items-center gap-3 px-7 py-4">
                <span className="w-8 h-8 flex items-center justify-center bg-amber-700/25 border border-amber-600/25 rounded-sm flex-shrink-0">
                  <i className={`${s.icon} text-amber-400 text-sm`} />
                </span>
                <div>
                  <p className="text-white font-bold text-lg leading-none tracking-tight">{s.value}</p>
                  <p className="text-white/45 text-xs tracking-wide mt-0.5">{s.label}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* ── Scroll indicator ── */}
      <div className="absolute bottom-10 right-16 z-10 hidden lg:flex flex-col items-center gap-2.5">
        <div className="w-px h-16 bg-gradient-to-b from-white/40 to-transparent" />
        <p className="text-white/35 text-[9px] tracking-[0.4em] uppercase rotate-90 origin-center mt-2">
          Scroll
        </p>
      </div>
    </section>
  );
}
